import React from 'react';
import classNames from 'classnames';

import { ExpandableText } from '../../../../components/helpers';
import { LinkButton } from '../../../../components/ui/buttons';

import { withI18n } from '../../../../components/context/i18n';
import compose from '../../../../lib/utils/compose';
import { withTPA } from '../../../../components/context/tpa';
import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';

const MAX_DESCRIPTION_LENGTH_DESKTOP = 300;
const MAX_DESCRIPTION_LENGTH_MOBILE = 110;

function HeaderDescription({
  dynamicStyle,
  styles,
  description,
  descriptionExcerpt,
  t,
  tpa,
}) {
  const { deviceType } = tpa.params;
  const maxTextLength =
    deviceType === TPADeviceType.MOBILE
      ? MAX_DESCRIPTION_LENGTH_MOBILE
      : MAX_DESCRIPTION_LENGTH_DESKTOP;

  return (
    <div
      data-hook="main.header.description"
      className={classNames(
        styles.headerDescriptionContainer,
        dynamicStyle.headerDescriptionContainer,
      )}
    >
      <ExpandableText
        text={descriptionExcerpt}
        textExpanded={description}
        textClassName={classNames(
          styles.headerDescription,
          dynamicStyle.headerDescription,
          dynamicStyle.headerDescriptionShort,
        )}
        expandedTextClassName={classNames(
          styles.headerDescription,
          dynamicStyle.headerDescription,
        )}
        maxTextLength={maxTextLength}
        renderToggleButton={({ isExpanded, toggle }) => (
          <LinkButton
            onClick={toggle}
            className={classNames(
              styles.headerReadMore,
              dynamicStyle.headerReadMore,
            )}
            aria-expanded={isExpanded ? 'true' : 'false'}
          >
            {!isExpanded
              ? t('pages.main.description-expand')
              : t('pages.main.description-collapse')}
          </LinkButton>
        )}
      />
    </div>
  );
}

export default compose(withI18n, withTPA)(HeaderDescription);
